import { CardMedia } from "@mui/material";
import { PDFViewer } from "../../Utility/PDFViewer"

/**
 * 在籍証明を表示する
 * PDF、またはjpegを表示可能
 * @param certificate PDFファイル
 * @param certificateBase64 Base64形式のjpegファイル
 * @returns 在籍証明表示エレメント
 */
export function CertificateIndicator(certificate:File | null | undefined, certificateBase64:string | undefined) {

    if (certificate?.type === "application/pdf") {
        return PDFViewer(certificate, 300)
    } else {
        return <CardMedia component="img" src={certificateBase64} sx={{width:300}}/>
    }
}